module.exports = __webpack_public_path__ + "img/L4.65a9170e.png";